<i18n lang='yml' src='./LogbooksWidget.yml'></i18n>
<template>
  <div class="row">
    <div class="col-md-12 col-lg-9 offset-lg-3">
      <div class="alert alert-danger" role="alert" v-if="error">
        {{$t('loading_error') }}
      </div>
      <div class="col-trans-right">
        <div class="layout-tile">
          <h4 class="heading-block d-flex">
            {{ $t('logbooks')}}
          </h4>
          <div class="content-block content-block-logbook" v-for="logbook in logbookList">
            <div class="post-view">
              <div class="post-content">
                <div class="view-area d-flex">
                  <a :href="`${locale}/users/${username}/logbooks/${logbook.id}`">{{logbook.name}}</a>
                </div> 
              </div>
            </div>
            <hr class="m-0" />
            <div class="post-meta">
              <ul class="list-unstyled list-inline list-annotation">
                <li class="list-inline-item">{{ $t('last_updated')}} : {{ formatDate(logbook.updated_at) }}</li>
              </ul>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatDate} from '../shared/typescripts/dates.ts'
export default {
  props: ['locale', 'logbooks', 'username'],
  data() {
    return {
      logbookList: [],
      error: false
    }
  },
  mounted() {
    try {
      this.logbookList = JSON.parse(this.logbooks) || [];
    }
    catch(err) {
      this.error = true
    }
  },
  
  methods: {
    //TODO: Revisit to standardize
    // Used for turning our system dates into a standard human readable format
    formatDate(dateString) {
      return formatDate(dateString)
    },
  }
}
</script>
